






import { Component, Vue } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import {
    getCustomer,
    postCustomer,
    patchCustomer,
    getUser,
    getCustomersPrescriber,
    getCustomerPrescriber,
    postCustomerPrescriber,
    patchCustomerPrescriber,
} from '../api/api';
import Customer from '../models/Customer';
import moment from 'moment';
import MetaDatatable from '@/models/MetaDatatable';
import User from '../models/User';
import get from 'lodash/get';
import AuthModule from '../store/AuthModule';
import { customerTypes } from '@/data/customerTypes';
import { customerStatus } from '@/data/customerStatus';
import { civilities, families } from '../data/civilitiesCustomer';
import { Route } from 'vue-router';
import formatCustomer from '../utils/formatCustomer';

let customer: Customer | null = null;

async function computeBreadcrumb(to: Route, from: Route, next: Function) {
    try {
        let datacustomer;
        if (AuthModule.roles.includes('ROLE_PRESCRIBER')) {
            datacustomer = await getCustomerPrescriber(+to.params.id);
        } else {
            datacustomer = await getCustomer(+to.params.id);
        }

        customer = datacustomer.data;
        to.meta.breadcrumb[2].title = formatCustomer(customer);
    } catch (error) {
        if (error.response.status == 404) {
            Vue.prototype.$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Client introuvable.`,
            });

            next({
                name: 'customers',
            });
            return;
        }
    }
    next();
}

@Component({
    beforeRouteEnter: computeBreadcrumb,
    beforeRouteUpdate: computeBreadcrumb,
    components: {
        Forms,
    },
})
export default class CustomerForm extends Vue {
    errors: any = {};
    error: string | null = null;
    title: string = '';
    customer: Customer | null = customer;
    loading: boolean = false;
    metaPrescriber: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: -1,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: { role: 'ROLE_PRESCRIBER' },
    };
    get type(): 'edit' | 'add' {
        return this.$route.name === 'addCustomer' ||
            this.$route.name === 'addProspects'
            ? 'add'
            : 'edit';
    }
    get items() {
        return [
            {
                name: 'civility',
                label: 'Civilité *',
                type: 'select',
                required: true,
                items: this.customerCivilitiesArr,
            },
            {
                name: 'family_situation',
                label: 'Situation familiale *',
                type: 'select',
                required: true,
                items: this.customerFamilyArr,
            },
            {
                name: 'first_firstname',
                label: 'Prénom *',
                type: 'text',
                errorMessage: 'Le prénom est requis',
                hidden: this.values.civility === 'Société',
                required: this.values.civility !== 'Société',
            },
            {
                name: 'first_lastname',
                label: 'Nom *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                hidden: this.values.civility === 'Société',
                required: this.values.civility !== 'Société',
            },
            {
                name: 'second_firstname',
                label: 'Deuxième Prénom *',
                type: 'text',
                errorMessage: 'Le prénom est requis',
                hidden:
                    this.values.civility === 'M.' ||
                    this.values.civility === 'Mme.' ||
                    this.values.civility === 'Société',
                required:
                    this.values.civility === 'M. et Mme.' ||
                    this.values.civility === 'M. et M.' ||
                    this.values.civility === 'Mme. et Mme.',
            },
            {
                name: 'second_lastname',
                label: 'Deuxième Nom *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                hidden:
                    this.values.civility === 'M.' ||
                    this.values.civility === 'Mme.' ||
                    this.values.civility === 'Société',
                required:
                    this.values.civility === 'M. et Mme.' ||
                    this.values.civility === 'M. et M.' ||
                    this.values.civility === 'Mme. et Mme.',
            },
            {
                name: 'company_name',
                label: 'Nom de la société *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                hidden: this.values.civility !== 'Société',
                required: this.values.civility === 'Société',
            },
            {
                name: 'type',
                label: 'Type *',
                type: 'select',
                items: this.customerTypesArr,
                errorMessage: 'Le type est requis',
                required: true,
            },
            {
                name: 'status',
                label: 'Statut',
                type: 'select',
                items: this.customerStatusArr,
            },
            {
                name: 'email',
                label: 'Email *',
                type: 'text',
                errorMessage: "L'email est requis",
                required: true,
            },
            {
                name: 'phone',
                label: 'Téléphone',
                type: 'text',
            },
            {
                name: 'mobile',
                label: 'Mobile',
                type: 'text',
            },
            {
                name: 'workplace',
                label: 'Lieu de travail',
                type: 'text',
            },
            {
                name: 'income_taxe',
                label: 'Montant IR payés (€/an)',
                type: 'number',
            },
            {
                name: 'first_household_reference_income_taxe',
                label: 'RFR Année N-1',
                type: 'number',
            },
            {
                name: 'second_household_reference_income_taxe',
                label: 'RFR Année N-2',
                type: 'number',
            },
            {
                name: 'people_in_tax_home',
                label: 'Nombre de personne dans le foyer fiscal',
                type: 'number',
            },
            {
                name: 'childrens_in_tax_home',
                label: 'Nombre d\'enfants à charge',
                type: 'number',
            },
            {
                name: 'monthly_pay',
                label: 'Revenus net mensuels',
                type: 'number',
            },
            {
                name: 'share_of_taxe_home',
                label: 'Nombre de part fiscal',
                type: 'number',
            },

            {
                denounces: [{
                    project: 'test',
                    file: 'test',
                    message_text: ''

                }
                ]
            },

            {
                name: 'address',
                type: 'address',
                fields: {
                    street: {
                        label: 'Adresse',
                        name: 'street',
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal *',
                        name: 'postal_code',
                    },
                    city: {
                        label: 'Ville *',
                        name: 'city',
                    },
                },
            },

        ];
    }
    defaultValue: any | null = {
        type: null,
        civility: null,
        family_situation: null,
        first_firstname: null,
        first_lastname: null,
        second_firstname: null,
        second_lastname: null,
        company_name: null,
        email: null,
        birthdate: null,
        phone: null,
        mobile: null,
        workplace: null,
        income_taxe: null,
        first_household_reference_income_taxe: null,
        second_household_reference_income_taxe: null,
        share_of_taxe_home: null,
        people_in_tax_home: null,
        childrens_in_tax_home: null,
        monthly_pay: null,
        status: null,
        address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
    };
    values: any = this.defaultValue;

    async created(): Promise<void> {
        this.loading = true;
        if (this.type === 'edit' && this.customer) {
            this.defaultValue.type = this.customer.type || null;
            this.defaultValue.civility = this.customer.civility || null;
            this.defaultValue.first_firstname =
                this.customer.first_firstname || null;
            this.defaultValue.first_lastname =
                this.customer.first_lastname || null;
            this.defaultValue.second_firstname =
                this.customer.second_firstname || null;
            this.defaultValue.second_lastname =
                this.customer.second_lastname || null;
            this.defaultValue.company_name = this.customer.company_name || null;
            this.defaultValue.email = this.customer.email || null;
            this.defaultValue.birthdate =
                (this.customer.birthdate &&
                    moment(this.customer.birthdate).format('YYYY-MM-DD')) ||
                null;
            this.defaultValue.phone = this.customer.phone || null;
            this.defaultValue.mobile = this.customer.mobile || null;
            this.defaultValue.workplace = this.customer.workplace || null;
            this.defaultValue.income_taxe = this.customer.income_taxe || null;
            this.defaultValue.first_household_reference_income_taxe =
                this.customer.first_household_reference_income_taxe || null;
            this.defaultValue.second_household_reference_income_taxe =
                this.customer.second_household_reference_income_taxe || null;
            this.defaultValue.share_of_taxe_home =
                this.customer.share_of_taxe_home || null;
            this.defaultValue.people_in_tax_home =
                this.customer.people_in_tax_home || null;
            this.defaultValue.monthly_pay =
                this.customer.monthly_pay || null;
            this.defaultValue.childrens_in_tax_home =
                this.customer.childrens_in_tax_home || null;
            this.defaultValue.address.street =
                (this.customer.address && this.customer.address.street) || null;
            this.defaultValue.address.street2 =
                (this.customer.address && this.customer.address.street2) ||
                null;
            this.defaultValue.address.postal_code =
                (this.customer.address && this.customer.address.postal_code) ||
                null;
            this.defaultValue.status =
                (this.customer.status && this.customer.status) || null;
            this.defaultValue.address.city =
                (this.customer.address && this.customer.address.city) || null;
        }
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const newCustomer: Customer = {
            type: form.type,
            civility: form.civility,
            family_situation: form.family_situation,
            first_firstname: form.first_firstname,
            first_lastname: form.first_lastname,
            second_firstname: form.second_firstname,
            second_lastname: form.second_lastname,
            company_name: form.company_name,
            email: form.email,
            birthdate: form.birthdate,
            phone: form.phone,
            mobile: form.mobile,
            workplace: form.workplace,
            income_taxe: form.income_taxe,
            second_household_reference_income_taxe:
                form.second_household_reference_income_taxe,
            first_household_reference_income_taxe:
                form.first_household_reference_income_taxe,
            share_of_taxe_home: form.share_of_taxe_home,
            people_in_tax_home: form.people_in_tax_home,
            childrens_in_tax_home: form.childrens_in_tax_home,
            monthly_pay: form.monthly_pay,
            status: form.status,
            email_2: '',
            mobile_2: '',
            address: {
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
            },
        };
        const $vs = (this as any).$vs;
        try {
            if (this.type === 'add') {
                if (AuthModule.roles.includes('ROLE_PRESCRIBER')) {
                    await postCustomerPrescriber(newCustomer);
                } else {
                    await postCustomer(newCustomer);
                }
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création du client réussie`,
                });
            } else {
                if (AuthModule.roles.includes('ROLE_PRESCRIBER')) {
                    await patchCustomerPrescriber(
                        +this.$route.params.id,
                        newCustomer
                    );
                } else {
                    await patchCustomer(+this.$route.params.id, newCustomer);
                }
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `Modification du client réussie`,
                });
            }
            if (AuthModule.roles.includes('ROLE_PRESCRIBER')) {
                this.$router.push({ name: 'prospects' });
            } else {
                this.$router.push({ name: 'customers' });
            }
        } catch (error) {
            this.errors = error.response.data.errors.children;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }

    get customerFamilyArr() {
        return Object.keys(families).map(key => ({
            text: (families as any)[key],
            value: key,
        }));
    }

    get customerTypesArr() {
        return Object.keys(customerTypes).map(key => ({
            text: (customerTypes as any)[key],
            value: key,
        }));
    }

    get customerStatusArr() {
        return Object.keys(customerStatus).map(key => ({
            text: (customerStatus as any)[key],
            value: key,
        }));
    }

    get customerCivilitiesArr() {
        return Object.keys(civilities).map(key => ({
            text: (civilities as any)[key],
            value: key,
        }));
    }

    tugudu(value: any) {
        if (value.civility === 'Société') {
            value.first_firstname = null;
            value.second_firstname = null;
            value.first_lastname = null;
            value.second_lastname = null;
        }
        if (value.civility === 'M.' || value.civility === 'Mme.') {
            value.company_name = null;
            value.second_firstname = null;
            value.second_lastname = null;
        }
        if (
            value.civility === 'M. et M.' ||
            value.civility === 'Mme. et Mme' ||
            value.civility === 'M. et Mme.'
        ) {
            value.company_name = null;
        }
        this.values = value;
    }
}
